// Phase 5: Audit logging for sensitive operations
// Logs key actions to the audit_logs table for accountability.
// TypeScript source — auditLog.js is a thin re-export stub.

import { insertAuditLog, logAuthFailure as repoLogAuthFailure } from "../data/auditLogs";
import { logger } from "./logger";

// Coerce any details value into a stable string for the audit_logs.details
// TEXT column. Handles three cases:
//   • null / undefined         → ""  (so they don't get logged as "null"/"undefined")
//   • object / array           → JSON.stringify
//   • primitives (str/num/bool)→ String(...)
function detailsToString(details: unknown): string {
  if (details === null || details === undefined) return "";
  if (typeof details === "object") return JSON.stringify(details);
  return String(details);
}

// Log an audit event — fire-and-forget (never blocks the UI). Pass `requestId`
// for request-scoped actions so it lands in the first-class audit_logs.request_id
// column (db-61) that powers "People on this request".
export function logAudit(action: string, details?: unknown, requestId?: number | null): void {
  // Fire-and-forget: the repo logs an insert error; .catch guards against an
  // unexpected throw (e.g. the client not being ready) so logAudit never blocks
  // or breaks its caller.
  insertAuditLog(action, detailsToString(details), requestId).catch(function (e) {
    logger.warn("Audit log error:", e);
  });
}

// Log a FAILED sign-in — fire-and-forget. Use this (NOT logAudit) for the two
// no-session cases (login_failed / access_code_failed): the attempt has no auth
// session, so logAudit's RLS-guarded insert is silently denied. This routes
// through the db-175 SECURITY DEFINER RPC instead. Only those two actions are
// accepted server-side (a hard-coded allowlist).
export function logAuthFailure(action: string, details?: unknown): void {
  repoLogAuthFailure(action, detailsToString(details)).catch(function (e) {
    logger.warn("Auth failure audit error:", e);
  });
}
